import * as Colors from '../../constants/Colors';
import { SvgIconProps } from '../IconProps';
import { BaseSvgIcon } from '../BaseSvgIcon';

export type SadFaceIconProps = SvgIconProps & {
    color?: string;
};

export const SadFaceIcon = ({ color, ...props }: SadFaceIconProps) => (
    <BaseSvgIcon viewBox="0 0 18 18" fill="none" {...props}>
        <path
            d="M3.5 17C3.7381 15.3333 6.07143 12 9.5 12C12.9286 12 15.2619 15.3333 15.5 17"
            stroke={color}
            strokeWidth="3"
        />
        <circle cx="4" cy="4.5" r="2.5" fill={color} />
        <circle cx="14" cy="4.5" r="2.5" fill={color} />
    </BaseSvgIcon>
);

SadFaceIcon.defaultProps = {
    color: Colors.pink,
    height: '18px',
    width: '18px',
};
